import cx from "classnames";
import Link from "next/link";
import { type UrlObject } from "url";

import { Heading } from "common/ui/Heading";
import { Icon } from "common/ui/Icon";

import styles from "./Stepper.module.scss";

interface StepperProps {
  children: React.ReactNode,
}

export const Stepper = ({ children }: StepperProps) => {
  return (
    <div className={styles.Stepper}>
      {children}
    </div>
  )
}

interface StepProps {
  href: string | UrlObject,
  stepNo: number,
  isCurrentStep: boolean,
  isComplete: boolean,
  isClickable: boolean,
  hasError?: boolean,
  children: React.ReactNode,
}

const Step = ({
  href,
  stepNo,
  isCurrentStep,
  isComplete,
  isClickable,
  hasError,
  children,
}: StepProps) => {
  return (
    <Link
      className={cx(styles.Step, {
        [styles.disabled]: !isClickable,
      })}
      href={href}
    >
      <div className={cx(styles.Number, {
        [styles.Selected]: isCurrentStep,
        [styles.Completed]: isComplete,
        [styles.Clickable]: isClickable,
        [styles.Error]: hasError,
      })}>
        {hasError ? (
          <Icon icon="exclamation" />
        ) : isComplete ? (
          <Icon icon="check" />
        ) : (
          <Heading variant="h4">
            {stepNo}
          </Heading>
        )}
      </div>
      <Heading
        variant="h4"
        className={cx(styles.Title, {
          [styles.Completed]: isComplete,
          [styles.Selected]: isCurrentStep,
          [styles.Clickable]: isClickable,
        })}
      >
        {children}
      </Heading>
    </Link>
  )
}

Stepper.Step = Step;
